document.addEventListener("DOMContentLoaded", function() {
  if (!(window.gsap && window.ScrollTrigger)) return;
  gsap.registerPlugin(ScrollTrigger);
  // --- Fix for 100vh bug on mobile ---
const setVh = () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
};
window.addEventListener('resize', setVh);
window.addEventListener('orientationchange', setVh);
setVh(); // Run on initial load
// --- End of fix ---
  // המבנה החדש שעוטף את הכל
  ScrollTrigger.matchMedia({

    // =======================================================
    // ========  לוגיקה לדסקטופ (מסך רחב מ-600px)  ========
    // =======================================================
    "(min-width: 601px)": function() {
      
      // ----- התחלה: כל הקוד המקורי שלך מודבק כאן -----
      const cards = Array.from(document.querySelectorAll('.card-stack-cover .card-cover'));
        if (!cards || !cards.length) return;

      const section = document.querySelector('.card-stack-cover-section');
        if (!section) return; // לא להריץ כלום אם הסקשן לא קיים בעמוד
      const cardContainer = section.querySelector('.card-stack-outer');
      const mask = section.querySelector('.stack-mask');
      if (cards.length <= 1 || !section) return;

      // תפריט + מרווח
      const headerEl = document.querySelector('.header');
      const menuOffset = (headerEl ? headerEl.offsetHeight : 90) + 60;
      const cardHeaderGap = 56;
      //סקשיין הבא

      // חשב מינימום גובה כדי שהקלפים לא ייחתכו
      let totalHeaderHeight = (cards.length - 1) * cardHeaderGap;
      const lastCard = cards[cards.length - 1];
      const prevH = lastCard.style.height;
      lastCard.style.height = 'auto';
      const lastCardFullH = lastCard.offsetHeight;
      lastCard.style.height = prevH;

      cardContainer.style.minHeight = (totalHeaderHeight + lastCardFullH) + 'px';

      // אתחל את הקלפים מתחת למסך
      const cardStartY = window.innerHeight + menuOffset;
      cards.forEach((card, i) => {
        gsap.set(card, {
          y: cardStartY,
          zIndex: cards.length - i
        });
        //card.style.height = `${cardHeaderGap}px`;
        card.style.overflow = 'hidden';
        let body = card.querySelector('.card-body');
        if (body) body.style.display = 'none';
      });

      // חשוף את הקלף הראשון במלואו
      gsap.set(cards[0], {
        y: menuOffset + 50,
        opacity: 0,
        height: 'auto',
        overflow: 'visible',
        zIndex: cards.length + 1
      });

      ScrollTrigger.create({
        trigger: section,
        start: "top 80%",
        end: "top top",
        scrub: 1,
        onEnter: () => gsap.to(cards[0], { y: menuOffset, opacity: 1, duration: 0.5 }),
        onLeaveBack: () => gsap.to(cards[0], { y: menuOffset + 50, opacity: 0, duration: 0.5 })
      });
      let body0 = cards[0].querySelector('.card-body');
      if (body0) body0.style.display = 'block';

      // בנה ה-timeline של העלייה
      const tl = gsap.timeline({ paused: true });
      tl.to(mask, { y: '110vh', ease: 'none' }, 0);
      cards.forEach((card, i) => {
        if (i === 0) return;
        
        tl.add(`card-${i}`) 
          .to(card, {
            y: menuOffset + i * cardHeaderGap,
           // height: `${cardHeaderGap}px`,
            overflow: 'hidden',
            duration: 1,
            ease: 'power2.inOut',
            onStart() {
              card.style.zIndex = cards.length + i;
              let b = card.querySelector('.card-body');
              if (b) b.style.display = 'block';
            }
          }, i * 0.3-0.4);
      });
      
  

      ScrollTrigger.create({
        trigger: cardContainer,
        start: 'top top',
        end: `+=${cards.length * cardHeaderGap + lastCardFullH* 2}`, 
        pin: cardContainer,
        pinSpacing: true,
        scrub: 2.5,
        animation: tl,
        invalidateOnRefresh: true,
       /* snap: {
          snapTo: "labelsDirectional",
          duration: { min: 0.2, max: 0.5 },
          ease: "power1.inOut"
        }*/
      });
      // ----- סיום: כל הקוד המקורי שלך מודבק כאן -----
// פונקציית ניקוי שתרוץ כשהמסך יפסיק להתאים לדסקטופ
    }, // סוף הלוגיקה של הדסקטופ

    // =======================================================
    // ========   לוגיקה למובייל (מסך קטן מ-601px)   ========
    // =======================================================
    "(max-width: 600px)": function() {
// הדבק את הקוד הבא בתוך הפונקציה של (max-width: 600px)
// החלף את כל מה שיש בתוך "(max-width: 600px)" בקוד הבא:

// הדבק את הקוד הבא בתוך הפונקציה הריקה של (max-width: 600px)
const cards = gsap.utils.toArray('.card-stack-cover .card-cover');
const headers = gsap.utils.toArray('.card-stack-cover .card-header');

headers.forEach(header => {
    header.addEventListener('click', () => {
        const card = header.parentElement;
        const body = card.querySelector('.card-body');

        // בדוק אם הכרטיס הנוכחי כבר פתוח
        const isOpen = card.classList.contains('open');

        // סגור את כל הכרטיסים האחרים
        cards.forEach(otherCard => {
            if (otherCard !== card) {
                otherCard.classList.remove('open');
                let otherBody = otherCard.querySelector('.card-body');
                gsap.to(otherBody, {
                    height: 0,
                    paddingTop: 0,
                    duration: 0.3,
                    ease: 'power1.inOut',
                    onComplete: () => { otherBody.style.display = 'none'; }
                });
            }
        });

        // פתח או סגור את הכרטיס הנוכחי
        if (!isOpen) {
            card.classList.add('open');
            body.style.display = 'block'; // הפוך לגלוי לפני האנימציה
            gsap.fromTo(body, 
                { height: 0, paddingTop: 0 }, 
                { 
                    height: 'auto', 
                    paddingTop: 15,
                    duration: 0.3, 
                    ease: 'power1.inOut' 
                }
            );
        } else {
            card.classList.remove('open');
            gsap.to(body, {
                height: 0,
                paddingTop: 0,
                duration: 0.3,
                ease: 'power1.inOut',
                onComplete: () => { body.style.display = 'none'; }
            });
        }
    });
});

// פונקציית ניקוי כדי שהאקורדיון לא יפריע לדסקטופ
return () => {
    headers.forEach(header => {
        // מסירים את ה-event listeners כדי למנוע כפילויות
        let newHeader = header.cloneNode(true);
        header.parentNode.replaceChild(newHeader, header);
    });
};
    } // סוף הלוגיקה של המובייל

  },300); // סוף מבנה matchMedia
});